import { useState, useEffect } from 'react';
import { getSectionQuestions, saveAnswers } from '../../api';

const SUBSECTIONS = [
  { title: 'Management', codes: ['MGMT_RP_NOMINATED', 'MGMT_DEPUTIES_NOMINATED', 'MGMT_DEPUTIES_APPOINTED', 'MGMT_SIGNED_ACCEPT', 'MGMT_RP_DESCRIPTION'] },
  { title: 'Written Scheme', codes: ['WS_SCHEME_EXISTS', 'WS_SCHEME_ADEQUATE', 'WS_DUTIES_DEFINED'] },
  { title: 'Communication', codes: ['COMM_PROCEDURE_DEFINED', 'COMM_ONSITE_EFFECTIVE', 'COMM_SUBCON_DEFINED', 'COMM_SUBCON_EFFECTIVE'] },
  { title: 'Training', codes: ['TRAIN_NEEDS_IDENTIFIED', 'TRAIN_COMPETENCE_ASSESSED', 'TRAIN_ALL_TRAINED', 'TRAIN_WRITTEN_RECORD', 'TRAIN_REVIEW_PROCEDURE'] },
  { title: 'Records', codes: ['REC_UPTODATE_SITE', 'REC_UPTODATE_CONTRACTORS', 'REC_WHO_MAINTAINS', 'REC_CENTRAL_SYSTEM', 'REC_AUDIT_SYSTEM', 'REC_SCHEMATICS', 'REC_LEGIONELLA_HISTORY'] },
  { title: 'Written Procedures', codes: ['PROC_NORMAL_OPS', 'PROC_STARTUP', 'PROC_SHUTDOWN', 'PROC_OOS_MICRO', 'PROC_OOS_OTHER', 'PROC_MONITORING_SITE', 'PROC_MONITORING_SUBCON'] },
];

export default function ManagementTab({ report, sections, onSave, readOnly = false }) {
  const mgmtSection = sections.find((s) => s.code === 'MGMT_COMM_CTRL');
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!mgmtSection) return;
    getSectionQuestions(mgmtSection.id).then((qs) => {
      setQuestions(qs);
      const ans = {};
      qs.forEach((q) => {
        const existing = (report.answers || []).find((a) => a.questionId === q.id);
        ans[q.id] = { id: existing?.id || null, answerText: existing?.answerText || '' };
      });
      setAnswers(ans);
    });
  }, [mgmtSection, report.answers]);

  const handleChange = (qId, val) => {
    setAnswers({ ...answers, [qId]: { ...answers[qId], answerText: val } });
  };

  const handleSave = async () => {
    const data = Object.entries(answers).map(([qId, a]) => ({
      id: a.id,
      questionId: Number(qId),
      answerText: a.answerText,
    }));
    try {
      await saveAnswers(report.id, data);
      setMsg('All answers saved');
      onSave();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const getQ = (code) => questions.find((q) => q.code === code);

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {SUBSECTIONS.map((sub) => (
        <div key={sub.title} style={{ marginBottom: '1.5rem' }}>
          <h3 style={{ fontSize: '1rem', color: '#1a1a2e', marginBottom: '0.5rem', borderBottom: '1px solid #eee', paddingBottom: '0.25rem' }}>{sub.title}</h3>
          <div className="table-scroll">
            <table className="data-table">
              <thead><tr><th>Process</th><th style={{ width: 200 }}>Status</th></tr></thead>
              <tbody>
                {sub.codes.map((code) => {
                  const q = getQ(code);
                  if (!q) return null;
                  return (
                    <tr key={q.id}>
                      <td style={{ fontSize: '0.85rem' }}>{q.questionText}</td>
                      <td><input value={answers[q.id]?.answerText || ''} onChange={(e) => handleChange(q.id, e.target.value)} disabled={readOnly} style={{ width: '100%', padding: '0.3rem' }} /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ))}
      {!readOnly && <button className="btn btn-primary" onClick={handleSave}>Save All Answers</button>}
    </div>
  );
}
